import { render, staticRenderFns } from "./SettledDateChips.vue?vue&type=template&id=dc8e3f54"
import script from "./SettledDateChips.vue?vue&type=script&lang=js"
export * from "./SettledDateChips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports